var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{style:(_vm.multiple ? { width: '340px' } : {}),attrs:{"options":_vm.branches,"props":_vm.branchesProps,"placeholder":"请选择所属部门","clearable":"","size":"small","collapse-tags":_vm.multiple},model:{value:(_vm.checkedBranch),callback:function ($$v) {_vm.checkedBranch=$$v},expression:"checkedBranch"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7c0bc4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/UserCascader.vue
// module id = 1203
// module chunks = 0